import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { REQ_STATUS } from 'src/app/constants/general';
import { ImgZipperService } from 'src/app/services/img-zipper.service';

@Component({
  selector: 'app-img-zipper',
  templateUrl: './img-zipper.component.html',
  styleUrls: ['./img-zipper.component.scss'],
})
export class ImgZipperComponent implements OnInit {
  @Output() formChange = new EventEmitter<FormGroup>();

  campaingTypes = [
    'App Campaign Estatico',
    'App Campaign Estatico Video',
    'Engagement',
    'Engagement Video',
    'App Campaign Animado',
    'Demand Gen Campaigns Fijo',
    'Demand Gen Campaigns Animado',
    'Responsive Ads',
    'GDN',
    'Performance Max',
    'Performance Max Video',
    'Discovery Feeds',
    'Discovery Carrusel',
    'Text Ads',
  ];

  imgZipperForm: FormGroup;
  formSub: Subscription;
  fileName: string;
  matchedZip = {
    reqStatus: REQ_STATUS.INITIAL,
  };
  matchInfo = {
    data: [],
    reqStatus: REQ_STATUS.INITIAL,
    errMsg: '',
  };

  constructor(
    private formBuilder: FormBuilder,
    private imgzipperService: ImgZipperService
  ) {}

  ngOnInit(): void {
    this.imgZipperForm = this.formBuilder.group({
      campaignType: ['', Validators.required],
      campaignName: ['', Validators.required],
      file: [null, Validators.required],
    });

    this.formChange.emit(this.imgZipperForm);
    this.formSub = this.imgZipperForm.valueChanges
      .pipe(debounceTime(5))
      .subscribe(() => {
        this.formChange.emit(this.imgZipperForm);
      });
  }

  onStepChange() {
    this.matchZip();
    this.getMatchInfo();
  }

  onFileSelected(event) {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.imgZipperForm.controls['file'].setValue(file);
    }
  }

  matchZip() {
    this.matchedZip.reqStatus = REQ_STATUS.LOADING;

    this.imgzipperService
      .matchZip(
        this.imgZipperForm.value.campaignType.toLowerCase().replace(/\s/g, ''),
        this.imgZipperForm.value.campaignName,
        this.imgZipperForm.value.file
      )
      .subscribe(
        (resp: any) => {
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(resp);
          a.href = objectUrl;
          a.download = `${this.imgZipperForm.value.campaignType}_${this.imgZipperForm.value.campaignName}.zip`;
          a.click();
          URL.revokeObjectURL(objectUrl);

          this.matchedZip.reqStatus = REQ_STATUS.SUCCESS;
        },
        (error) => {
          this.matchedZip.reqStatus = REQ_STATUS.ERROR;
        }
      );
  }

  getMatchInfo() {
    this.matchInfo.data = [];
    this.matchInfo.reqStatus = REQ_STATUS.LOADING;

    this.imgzipperService
      .getMatchInfo(
        this.imgZipperForm.value.campaignType.toLowerCase().replace(/\s/g, ''),
        this.imgZipperForm.value.campaignName,
        this.imgZipperForm.value.file
      )
      .subscribe(
        (resp: any) => {
          this.matchInfo.data = resp;
          this.matchInfo.reqStatus = REQ_STATUS.SUCCESS;
        },
        (error) => {
          this.matchInfo.errMsg =
            'Ocurrió un problema al generar el resumen de la evaluación: ' +
            error.error.Message;
          this.matchInfo.data = [];
          this.matchInfo.reqStatus = REQ_STATUS.ERROR;
        }
      );
  }
}
